import './main.css'

import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import { initBlogToc } from './blog-toc.js'
import { contactForm } from './contact-form.js'
import { feedbackForm } from './feedback-form.js'

window.Alpine = Alpine
Alpine.plugin(collapse)
Alpine.data('contactForm', contactForm)
Alpine.data('feedbackForm', feedbackForm)
Alpine.start()

initBlogToc()
